import React, { PureComponent } from 'react';
import { css } from 'emotion';

import Input from '../../../../../../js/common/components/core/Input';
import { debounce } from '../../../../../../js/main/support/utils';

import Colors from '../../../../../../styles/Colors';
import Icons from '../../../../../../styles/Icons';

const styles = {
  searchIcon: css({
    fontFamily: 'Material Icons',
    fontSize: '18px',
    color: Colors['@gray-chateau'],
    padding: '6px',
    marginLeft: '30px',
    position: 'absolute'
  }),
  inputContainer: css({
    display: 'flex',
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '12px',
    marginBottom: '12px'
  }),
  input: css({
    flex: '1',
    boxSizing: 'border-box',
    border: `0.7px solid ${Colors['@gallery']}`,
    borderRadius: '17px',
    outline: 'none',
    paddingLeft: '40px'
  })
};

class DiscoAdsIntentSearchBar extends PureComponent {
  _onChange = e => {
    this.props.onChange(e.target.value);
  };

  render() {
    const { searchIcon, inputContainer, input } = styles;
    const { userQuery } = this.props;
    return (
      <div>
        <i className={searchIcon}>{Icons.SEARCH}</i>
        <Input
          testid="intents-modal-search-bar"
          autoFocus
          value={userQuery}
          onChange={debounce(e => this._onChange(e), 1000)}
          className={inputContainer}
          inputClassName={input}
          placeholder="Search for Intents"
          i13nLabel="Disco Intents Search Bar"
        />
      </div>
    );
  }
}

export default DiscoAdsIntentSearchBar;
